import { hasProperty } from './propertyAccessUtils';

/**
 * Returns the value of @property in @crmObject with its type corrected to the expected
 * type based on the property being accessed.
 *
 * If @property is not present:
 *   - returns undefined when @defaultValue is not provided.
 *   - returns @defaultValue otherwise.
 * @param crmObject The Content CRM object
 * @param property The property name
 * @param defaultValue Optional default value if @property is not found in @crmObject
 */

export function getContentPropertyValue(crmObject, property, defaultValue) {
  if (!property) return undefined;
  if (hasProperty(crmObject, property)) {
    const rawPropertyValue = crmObject.properties[property].rawValue;
    if (rawPropertyValue === undefined || rawPropertyValue === null) {
      return defaultValue || rawPropertyValue;
    }
    return rawPropertyValue;
  }
  return defaultValue;
}